import {
    BS_IMAGE_CAPTION_TYPE,
    BS_IMAGE_FIGURE_TYPE,
    BS_IMAGE_IMG_TYPE,
} from './constants';

const normalizeText = (value) =>
    String(value || '')
        .replace(/\u00a0/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

function parseCaptionHtml(html) {
    if (!html) return '';

    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return normalizeText(tmp.textContent);
}

export function findCaptionInFigure(figure) {
    if (!figure) return null;

    return (
        figure.findType(BS_IMAGE_CAPTION_TYPE)[0] ||
        figure.components().find(
            (child) => (child.get('tagName') || '').toLowerCase() === 'figcaption'
        ) ||
        null
    );
}

export function toCaptionPlainText(value) {
    return parseCaptionHtml(value);
}

export function getCaptionText(captionModel) {
    if (!captionModel) return '';

    const modelText = parseCaptionHtml(captionModel.get('content') || '');
    const innerText = parseCaptionHtml(captionModel.getInnerHTML?.() || '');
    const liveText = normalizeText(captionModel.view?.el?.textContent);

    return innerText || modelText || liveText;
}

export function resolveBsImageFigure(component) {
    if (!component) return null;

    const type = component.get('type');
    if (type === BS_IMAGE_FIGURE_TYPE) return component;

    if (type === BS_IMAGE_IMG_TYPE || type === BS_IMAGE_CAPTION_TYPE) {
        const parent = component.parent();
        if (parent?.get('type') === BS_IMAGE_FIGURE_TYPE) return parent;
    }

    return null;
}

export function resolveBsImageImg(component) {
    if (!component) return null;
    if (component.get('type') === BS_IMAGE_IMG_TYPE) return component;

    if (component.get('type') === BS_IMAGE_FIGURE_TYPE) {
        return (
            component.findType(BS_IMAGE_IMG_TYPE)[0] ||
            component.components().find(
                (child) => (child.get('tagName') || '').toLowerCase() === 'img'
            ) ||
            null
        );
    }

    return null;
}
